import React, { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link, useNavigate } from "react-router-dom";
// import "../../../public/default.jpg"

const RecentlyJoined = () => {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/get-users.php`
      )
      .then((response) => {
        setUsers(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching users!", error);
      });
  }, []);

  // Function to calculate age from DOB
  const calculateAge = (dob) => {
    if (!dob) return "N/A";
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  // Function to format height (assuming height is stored as "feet.inches" like "5.6")
  const formatHeight = (height) => {
    if (!height) return "N/A";
    const parts = height.split(".");
    if (parts.length === 2) {
      return `${parts[0]}'${parts[1]}"`;
    }
    return height;
  };

  return (
    <div className="recently-joined-container">
      <div className="content-wrapr container"  style={{padding:"0"}}>
        <div className="heading">
          <h3 className="text-center">
            Recently Joined Members –{" "}
            <span style={{ color: "#E53D5C" }}>Start Connecting Now!</span>
          </h3>
        </div>

        <div className="swiper-container" >

          {/* <button className="swiper-nav swiper-nav-prev"></button>
          <button className="swiper-nav swiper-nav-next"></button> */}
          <Swiper
            onClick={() => navigate('/login')}
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={0}
            slidesPerView={1}
            navigation
            // pagination={{ clickable: true }}
            autoplay={{
              delay: 3000,
            }}
            loop={true}
            loopedSlides={users.length}
            breakpoints={{

              1024: {
                slidesPerView: 3.5,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2.5,
                spaceBetween: 15,
              },
              500: {
                slidesPerView: 1,
                spaceBetween: 0,
              },
            }}
          >
            {users.map((member, index) => (
              <SwiperSlide key={index}>
                <div className="member-card" style={{ cursor: "pointer" }}>
                  <img
                    src={
                      member.image1
                        ? `${process.env.REACT_APP_API_BASE_URL}${member.image1}`
                        : "/default.jpg"
                    }
                    alt={member.name}
                    onError={(e) => {
                      e.target.src = "/default.jpg";
                    }}
                    className="member-image"
                  />

                  <div className="member-info">
                    <h5>{member.name}</h5>
                    <div className="member-id-gender">
                      <span className="member-id">
                        {member.gender === "male"
                          ? "M"
                          : member.gender === "female"
                            ? "F"
                            : ""}
                      </span>
                      <span className="member-id">HS{member.user_id}</span>
                    </div>

                    <div className="member-details">
                      <div className="detail-row">
                        <span className="detail-label">Age:</span>
                        <span className="detail-value">
                          {calculateAge(member.dob)} Yrs
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Height:</span>
                        <span className="detail-value">
                          {formatHeight(member.height)}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Gender:</span>
                        <span className="detail-value">
                          {member.gender === "male"
                            ? "Male"
                            : member.gender === "female"
                              ? "Female"
                              : "N/A"}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Caste:</span>
                        <span className="detail-value">
                          {member.caste || "N/A"}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Location:</span>
                        <span className="detail-value">
                          {member.curr_location || member.country || "India"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <p className="text-center my-0">
          <Link to={'/login'} className="view-more btn btn-outline-danger d-inline mx-auto">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" version="1.1" viewBox="0 0 17 17" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><g></g><path d="M6 8h-6v-6h1v4.109c1.013-3.193 4.036-5.484 7.5-5.484 3.506 0 6.621 2.36 7.574 5.739l-0.963 0.271c-0.832-2.95-3.551-5.011-6.611-5.011-3.226 0.001-6.016 2.276-6.708 5.376h4.208v1zM11 9v1h4.208c-0.693 3.101-3.479 5.375-6.708 5.375-3.062 0-5.78-2.061-6.611-5.011l-0.963 0.271c0.952 3.379 4.067 5.739 7.574 5.739 3.459 0 6.475-2.28 7.5-5.482v4.108h1v-6h-6z"></path></svg> View More Profile
          </Link>
        </p>

      </div>

      <style jsx>{`
        .member-info h5,
        .member-id {
          color: white !important;
          text-align: center;
        }
        .detail-label {
          color: white !important;
        }
        .detail-value {
          color: white !important;
        }
        .recently-joined-container {
          padding: 30px 0;
          background: #fff;
        }
        .content-wrapper {
          max-width: 1200px;
          margin: 0 auto;
        }
        .swiper-container {
          padding: 0;
          position: relative;
          margin-bottom: 30px;
        }
        .member-card {
          width: 100%;
          background: white;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease;
        }
        .member-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
        }
        .member-image {
          width: 100%;
          height: 400px;
          object-fit: cover;
          display: block;
        }
        .member-info {
          background: #e53d5c;
          color: white;
          padding: 15px;
        }
        .member-id-gender {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          justify-content: center;
        }
        .gender-badge {
          background: white;
          color: #e53d5c;
          border-radius: 3px;
          padding: 2px 5px;
          font-weight: bold;
          margin-right: 8px;
        }
        .member-id {
          font-weight: bold;
          font-size: 14px;
        }
        .member-details {
          font-size: 13px;
        }
        .detail-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 5px;
          padding-bottom: 5px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }
        .detail-row:last-child {
          border-bottom: none;
          margin-bottom: 0;
          padding-bottom: 0;
        }
        .detail-label {
          font-weight: 500;
        }
        .detail-value {
          text-align: right;
        }
        .view-more {
          display: block;
          text-align: center;
          color: #e53d5c;
          font-size: 16px;
          text-decoration: none;
          font-weight: bold;
          margin-top: 30px;
          transition: color 0.3s ease;
        }
      
        .swiper-button-next,
        .swiper-button-prev {
          color: #e53d5c;
          width: 40px;
          height: 40px;
          background: white;
          border-radius: 50%;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }
        .swiper-button-next:hover,
        .swiper-button-prev:hover {
          background: #e53d5c;
          color: white;
        }
        .swiper-button-next:after,
        .swiper-button-prev:after {
          font-size: 18px;
          font-weight: bold;
        }
        .swiper-pagination-bullet {
          background: #ccc;
          opacity: 1;
          width: 12px;
          height: 12px;
        }
        .swiper-pagination-bullet-active {
          background: #e53d5c;
        }
        @media (max-width: 768px) {
          .swiper-container { 
            padding: 0;
          }
          .swiper-button-next,
          .swiper-button-prev {
            display: none;
          }
        }
        @media (max-width: 480px) {
          .recently-joined-container {
            padding: 20px 15px;
          }
          .member-details {
            font-size: 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default RecentlyJoined;
